import { render, staticRenderFns } from "./FullScreenPoiPicker.vue?vue&type=template&id=2a61222a&scoped=true&"
import script from "./FullScreenPoiPicker.vue?vue&type=script&lang=js&"
export * from "./FullScreenPoiPicker.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenPoiPicker.vue?vue&type=style&index=0&id=2a61222a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a61222a",
  null
  
)

export default component.exports